import { gql } from "@apollo/client";

import { teamItemGqlFragment, toTeamType, TeamType } from "./teamItem";

import {
  ListDiscoverTeamsQuery,
  ListDiscoverTeamsQueryVariables,
} from "lib/types/graphql";

/* Get gql query variables */

export interface ApiParams {
  filter: {
    freetext: string;
  };
  page: number;
  pageSize: number;
}

export function getListDiscoverTeamsVariables(
  input: ApiParams
): ListDiscoverTeamsQueryVariables {
  return {
    filter_name: input.filter.freetext
      ? { _ilike: `%${input.filter.freetext}%` }
      : {},
    limit: input.pageSize,
    offset: input.pageSize * (input.page - 1),
  };
}

/* The actual query */
// Not assigned to constant here. Using generated. See _GrahphQL requests_ in readme.
gql`
  query ListDiscoverTeams(
    $filter_name: String_comparison_exp!
    $limit: Int!
    $offset: Int!
  ) {
    teams(
      where: { name: $filter_name }
      order_by: [{ received_stars: { sum: desc_nulls_last } }, { id: asc }]
      limit: $limit
      offset: $offset
    ) {
      ...TeamItem
    }
    teams_aggregate(where: { name: $filter_name }) {
      aggregate {
        count
      }
    }
  }

  ${teamItemGqlFragment}
`;

/* Selector: Transform team result data to more usable data structure */
export function transformData(
  data: ListDiscoverTeamsQuery
): {
  teams: TeamType[];
  total_count: number;
} {
  return {
    teams: data.teams.map(toTeamType),
    total_count: data.teams_aggregate?.aggregate?.count ?? 0,
  };
}
